module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "assign-promo-code"
  }, [_c('modal', {
    attrs: {
      "name": "assignPromoCode",
      "height": "auto",
      "scrollable": true
    },
    on: {
      "before-close": _vm.onClose,
      "before-open": _vm.reset
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('span', [_c('p', {
    staticStyle: {
      "color": "red",
      "margin-bottom": "20px",
      "font-weight": "bold",
      "font-size": "16px"
    }
  }, [_vm._v("Assign Promo Code")])]), _vm._v(" "), _c('div', {
    staticClass: "search-container"
  }, [_c('label', {
    staticStyle: {
      "display": "block",
      "margin-bottom": "5px"
    }
  }, [_vm._v("Search Promo Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%",
      "height": "40px",
      "border": "1px solid #ccc",
      "border-radius": "4px",
      "padding": "8px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Type to search..."
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }, _vm.onSearch]
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#666"
    }
  }, [_vm._v("Searching...")]) : _vm._e(), _vm._v(" "), (_vm.results.length > 0) ? _c('ul', {
    staticClass: "promo-results"
  }, _vm._l((_vm.results), function(code) {
    return _c('li', {
      key: code.id,
      class: {
        'selected': _vm.selectedCode && _vm.selectedCode.id === code.id
      },
      on: {
        "click": function($event) {
          return _vm.selectCode(code)
        }
      }
    }, [_vm._v("\n                " + _vm._s(code.code) + " \n                "), (code.description) ? _c('span', {
      staticStyle: {
        "color": "#888",
        "font-size": "12px",
        "margin-left": "10px"
      }
    }, [_vm._v(_vm._s(code.description))]) : _vm._e()])
  }), 0) : (!_vm.isLoading && _vm.searchQuery.length > 0 && _vm.results.length === 0) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#888"
    }
  }, [_vm._v("\n            No promo codes found.\n         ")]) : _vm._e()]), _vm._v(" "), (_vm.selectedCode) ? _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "padding": "10px",
      "background-color": "#f0f0f0",
      "border-radius": "4px"
    }
  }, [_c('strong', [_vm._v("Selected:")]), _vm._v(" " + _vm._s(_vm.selectedCode.code) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error-msg"
  }, [_c('span', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errorMessage))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    staticStyle: {
      "margin-right": "10px",
      "background-color": "#ccc",
      "border": "none",
      "padding": "0 20px",
      "border-radius": "4px",
      "cursor": "pointer",
      "display": "inline-flex",
      "align-items": "center",
      "justify-content": "center",
      "height": "38px",
      "min-width": "100px",
      "font-weight": "bold",
      "color": "#333"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('assignPromoCode')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    staticStyle: {
      "background-color": "red",
      "color": "white",
      "border": "none",
      "padding": "0 20px",
      "border-radius": "4px",
      "cursor": "pointer",
      "display": "inline-flex",
      "align-items": "center",
      "justify-content": "center",
      "height": "38px",
      "min-width": "100px",
      "font-weight": "bold"
    },
    style: ({
      opacity: _vm.selectedCode ? 1 : 0.5
    }),
    attrs: {
      "disabled": !_vm.selectedCode
    },
    on: {
      "click": _vm.assign
    }
  }, [_vm._v("Assign")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0503ab18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/AssignPromoCode.vue
// module id = 1648
// module chunks = 2